<template>
  <div id="page-sidebar-wrapper" :class="[pageSidebarWrapperClass, activeObject.toggleWidth]">
    <div id="sidebar-trigger" class="sidebar-trigger" aria-hidden="true" @click="changeObject">
      <span class="trigger-icon">
        <span class="trigger-icon_inner">
          <img :src="getImgSrc('icon-title-hamburger', isInactive)" class="icon-default"
        /></span>
      </span>
    </div>
    <div id="page-sidebar" :class="[pageSidebarClass, activeObject.toggleWidth]">
      <template v-if="displayedMenuLists">
        <div v-for="(group, key, groupIndex) in displayedMenuLists" :key="`group-key-${groupIndex}`">
          <!-- 運用メニュー/管理メニュー -->
          <div v-if="parseInt(isSidebarExpanded) === 1" class="my-4 pl-4 text-white text-xs">
            {{ $t(`top.${key}`) }}
          </div>
          <div v-else class="flex justify-center my-4 text-white text-xs">
            {{ $t(`top.${key}_short`) }}
          </div>
          <ul class="menu-items text-base-content">
            <li
              v-for="(menu, menuIndex) in group"
              :key="`menu-${groupIndex}-key-${menuIndex}`"
              class="menu-item py-2 pl-4"
              :class="{ disabled: isDisableSideMenuItem }"
            >
              <router-link :to="`/${menu.path}`" class="flex items-center text-white" @click="changeTab(menu.name)">
                <span v-if="menu.icon_sidebar" :class="activeObject.closedClass">
                  <img
                    :src="getImgSrc(menu.icon_sidebar, isActive)"
                    class="icon-active mr-1.5"
                    :alt="menu.name"
                    @error="getNoIconImgSrc($event, isActive)"
                  />
                  <img
                    :src="getImgSrc(menu.icon_sidebar, isInactive)"
                    class="icon-default mr-1.5"
                    :alt="menu.name"
                    @error="getNoIconImgSrc($event, isInactive)"
                  />
                </span>
                <span v-if="parseInt(isSidebarExpanded) === 1" class="text text-sm">
                  {{ menu.name }}
                </span>
              </router-link>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { sidebarBgMixin } from '@/member/mixins/styleMixin'

export default {
  name: 'TheSidebar',
  mixins: [sidebarBgMixin],
  data() {
    return {
      btnBack: {
        text: this.$t('sidebar.btn_back'),
        link: '#',
        icon: 'icon-menu-arrow-left',
      },
      isActive: true,
      isInactive: false,
      classObjects: [
        {
          closedClass: {
            icon: true,
          },
          toggleWidth: {
            'page-sidebar0': true,
          },
        },
        {
          closedClass: {
            icon: true,
            'py-ml-3.5': true,
          },
          toggleWidth: {
            'page-sidebar1': true,
          },
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['menuLists', 'isDisableSideMenuItem', 'isSidebarExpanded']),
    displayedMenuLists() {
      let result = {}
      for (const [key, value] of Object.entries(this.menuLists)) {
        if (value.length) {
          result[key] = value
        }
      }
      return result
    },
    activeObject() {
      return this.classObjects[this.isSidebarExpanded]
    },
    pageSidebarWrapperClass() {
      return Object.assign(this.pageSidebarClassWrapperObj, {})
    },
    pageSidebarClass() {
      return Object.assign(this.pageSidebarClassObj, { 'pb-32': true })
    },
  },
  async created() {
    await this.setMenu()
  },
  methods: {
    ...mapActions({
      setIsSidebarExpanded: 'commonStore/setIsSidebarExpanded',
      setManageImportTabId: 'manageImportStore/setManageImportTabId',
      getMenuList: 'masterMenuStore/getMenuList',
    }),
    async setMenu() {
      await this.getMenuList()
    },
    getImgSrc(icon, isActive) {
      if (isActive) {
        return `/images/member/${icon}-active.svg`
      }
      return `/images/member/${icon}.svg`
    },
    getNoIconImgSrc(e, isActive) {
      if (isActive) {
        e.target.src = `/images/member/icon-menu-no-icon-active.svg`
        return
      }
      e.target.src = `/images/member/icon-menu-no-icon.svg`
    },
    async changeObject() {
      // 0と1をトグル
      let isSidebarExpanded = 1 - this.isSidebarExpanded
      this.setIsSidebarExpanded(isSidebarExpanded)
    },
    // サイドバーからの遷移時の挙動
    changeTab(menuName) {
      if (menuName === 'データ取込管理') {
        // 森林経営計画ファイル取込　タブ選択
        this.setManageImportTabId(1)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#page-sidebar {
  min-height: calc(100vh - 92px);
}
.page-sidebar0 {
  min-width: 50px;
}
.page-sidebar1 {
  min-width: 200px;
}
.menu-item {
  position: relative;
  z-index: 1;
  a:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 100%;
    background: #fff;
    z-index: -1;
    transition: all 0.2s;
  }
  &:hover a,
  a.active {
    color: var(--color-primary);
    &:after {
      right: 0;
    }
    .icon-active {
      display: block;
    }
    .icon-default {
      display: none;
    }
  }
  // isDisableSideMenuItem の場合
  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
.icon {
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-active {
  display: none;
}
.btn-back {
  z-index: 10000;
  width: 100%;
  max-width: 200px;
  .icon {
    top: 6px;
  }
  a:hover {
    background: var(--color-green-dark);
    color: #fff !important;
    transition: all 0.2s;
    .icon-active {
      display: block;
    }
    .icon-default {
      display: none;
    }
  }
}
.sidebar-trigger {
  text-align: right;
  width: 100%;
}
.trigger-icon {
  display: block;
  opacity: 0.6;
  padding: 14px;
  cursor: pointer;
  .trigger-icon_inner {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    position: relative;
  }
}
</style>
